import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LocatiiComponent } from './locatii.component';
import { AddLocatieComponent } from './add-locatie/add-locatie.component';
import { EditLocatieComponent } from './edit-locatie/edit-locatie.component';
import { MaterialModule } from 'src/app/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';



@NgModule({
    declarations: [
        LocatiiComponent,
        AddLocatieComponent,
        EditLocatieComponent
    ],
    imports: [
        CommonModule, MaterialModule, FormsModule, ReactiveFormsModule
    ],
    exports: [LocatiiComponent]
})
export class LocatiiModule { }
